import { PrivateActMask, PublicActMask } from '@sda/sdk/masks';
import { Reducers } from '@sda/enums/store';
import { SDKFactory } from './helpers/sdk.factory';
import { SDK } from './helpers/sdk';
import type { FetchDataType, FirestoreClientData, Sitemap } from './interfaces';
import type { Invitation } from '@sda/interfaces/invitation';
import type { PublicAct, PrivateAct, Act } from '@sda/interfaces/act';

/**
 * SDK Class to interact with Firestore Acts.
 */
export class Acts extends SDK<PublicAct> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.ACTS);

    this.collection = this.fsh.Schema.PublicActs;

    this.PublicMap = PublicActMask;

    this.PrivateMap = PrivateActMask;
  }

  async getCombined(id: string): Promise<Act & FetchDataType> {
    return this.getCombinedRecord<PrivateAct>(
      id,
      this.Private().collection,
    );
  }

  Private(): typeof ExtendedSDK {
    interface PrivateSDK extends SDK<PrivateAct> {
      Invitations: (id: string) => SDK<Invitation>;
    }

    let ExtendedSDK = SDKFactory<PrivateAct>(this.fsh.clientData, this.fsh.Schema.PrivateActs, { reducerName: Reducers.ACTS }) as PrivateSDK;

    ExtendedSDK.Invitations = (id: string) => SDKFactory<Invitation>(
      this.fsh.clientData,
      this.fsh.getCollection<Invitation>(this.fsh.Schema.PrivateActs, id, 'Invitations'),
      { reducerName: Reducers.INVITATIONS },
    );

    return ExtendedSDK;
  }

  Sitemap(): SDK<Sitemap> {
    return SDKFactory<Sitemap>(this.fsh.clientData, this.fsh.Schema.Sitemap_Acts);
  }
}
